import { Drawer } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { NotesRichText } from './NotesRichText';
import { ReportNotesWindow } from './ReportNotesWindow';

interface ReportNotesProps {
  opened: boolean;
  value: string | null;
  onChange: (value: string | null) => void;
  disabled: boolean;
  onClose: () => void;
}

export function ReportNotes({ opened, value, onChange, disabled, onClose }: ReportNotesProps) {
  const isMobile = useMediaQuery('(max-width: 768px)');

  if (!opened) {
    return null;
  }

  if (isMobile) {
    return (
      <Drawer opened onClose={onClose} position="bottom" size="70%" title="Notizen">
        <div
          style={{
            height: '100%',
            minHeight: '50vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <NotesRichText value={value} onChange={onChange} disabled={disabled} />
        </div>
      </Drawer>
    );
  }

  return <ReportNotesWindow value={value} onChange={onChange} disabled={disabled} onClose={onClose} />;
}
